import { defineMessages } from 'react-intl';

const messages = defineMessages({
  requestsNoResults: {
    id: 'repvisits.notifications.requests.requestsNoResults',
    defaultMessage: 'You currently have no notifications',
  },
  requestsShowMore: {
    id: 'repvisits.notifications.requests.requestsShowMore',
    defaultMessage: 'Show More',
  },
});

export default messages;
